import MstRackTypeComponent from '../Components/Master/RackType.tsx';
import { getPageFunction, pageEnum } from '../../security/LoginDetail.js';

export default function MstRackType(){
    const pageFunction = getPageFunction({pageId : pageEnum.MstRackType});
    return (        
        <MstRackTypeComponent pageFunction={pageFunction} />
    );
}